export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/blog": [~4,[2]],
		"/blog/tag/[tag=BlogTag]": [~7,[2]],
		"/blog/[year=BlogYear]/[month=BlogMonthOrDay]/[day=BlogMonthOrDay]/[slug=BlogPostSlug]": [5,[2]],
		"/blog/[year=BlogYear]/[month=BlogMonthOrDay]/[day=BlogMonthOrDay]/[slug=BlogPostSlug]/mentions": [~6,[2]],
		"/cv": [8]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';